import React from "react";
import { Plan } from "../../../@types";
import { useTranslate } from "../../../helpers";
import { addProtocolToUrl } from "../../../helpers/objectUtilities";
import { sendTealiumEvent } from "../../../helpers";

export const DoctorServicesTableCaption: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const t = useTranslate();
  return (
    <div className="mct-c-table__caption-col--1">
      <h3 className="mct-c-table__caption-title">
        {t("plan_terms.doctor_services")}
      </h3>
      <a
        href={addProtocolToUrl(plan.provider_network_web_address || plan.url)}
        target="_blank"
        rel="noopener noreferrer"
        className="preview-disable-exempt"
        onClick={(): void => {
          sendTealiumEvent("Plan Details", "View Provider Network Directory");
        }}
      >
        {t("plan_terms.view_provider_network_directory")}
      </a>
    </div>
  );
};
